<template>
<v-container fluid grid-list-lg>
  <v-layout row v-if="loading">
    <progress-dialog>{{ $t('loading') }}</progress-dialog>
  </v-layout>
  <v-layout row wrap v-else>
    <v-flex xs12 v-for="c in charts" :key="c.activityId">
      <activity-chart :userId="userId" :title="c.title" :activityId="c.activityId" :hours="hours"></activity-chart>
    </v-flex>
    <v-flex xs12>
      <activity-list :userId="userId"></activity-list>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import activityChart from './activityChart'
import activityList from './activityList'
import {
  UserAuth
} from 'luffanet-web-components'

const ROWS = 50;

export default {
  name: 'Activity',
  mixins: [UserAuth],
  components: {
    'activity-chart': activityChart,
    'activity-list': activityList
  },
  data() {
    return {
      loading: true,
      hours: 7 * 24,
      charts: [{
        title: 'Control',
        activityId: 'control'
      }, {
        title: 'Juice',
        activityId: 'juice'
      }, {
        title: 'Cast',
        activityId: 'cast'
      }, {
        title: 'Face',
        activityId: 'face'
      }, {
        title: 'Whisper',
        activityId: 'whisper'
      }, {
        title: 'Twins',
        activityId: 'twins'
      }]
    }
  },
  methods: {
    load() {
      this.loading = false;
    }
  }
}
</script>

<style scoped>
.uppercase {
  text-transform: uppercase;
}
</style>



// WEBPACK FOOTER //
// src/components/activity.vue